<script lang="ts" setup>
import type { Podcast } from '~/types/podcasts'
import type { RouteLocationRaw } from 'vue-router'

const { podcast } = defineProps<{
  podcast: Podcast
}>()

const tags = computed(() => {
  const tags = []

  if (podcast.categories.length) {
    const categories: { title: string; route: RouteLocationRaw }[] = []

    podcast.categories.forEach((category) => {
      const subcategoryTitle = category.split('/')?.[1]

      if (!!subcategoryTitle?.length || !!category?.length) {
        categories.push({
          title: subcategoryTitle || category,
          route: { name: 'podcasts-categories-category', params: { category: category } },
        })
      }
    })

    if (categories.length) {
      tags.push(...categories)
    }
  }

  if (podcast.country) {
    tags.push({
      title: podcast.country,
      route: { name: 'podcasts-countries-country', params: { country: podcast.country } },
    })
  }

  if (podcast.language) {
    tags.push({
      title: podcast.language,
      route: { name: 'podcasts-languages-language', params: { language: podcast.language } },
    })
  }

  return tags
})
</script>

<template>
  <div v-if="tags.length" class="overflow-x-scroll hidden-scroll">
    <div class="flex md:flex-wrap gap-2">
      <TagLink v-for="tag in tags" :key="tag.title" :route="tag.route">{{ tag.title }}</TagLink>
    </div>
  </div>
</template>

<style scoped></style>
